export default __webpack_public_path__ + "static/media/tokenSpinStill.61fa69cc.png";